import { useState } from 'react';

import { StyledAppBar } from './sticky-nav.styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Drawer from '@mui/material/Drawer';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

import { IconLinks } from '../icon-links/icon-links';
import { PAGES, SITE_NAME } from './sticky-nav.const';
import { scrollToTop } from '../app.utils';
import { TEXT_PRIMARY } from '../app.styles';
import { APP_BAR_HEIGHT } from './sticky-nav.const';

export const StickyNav = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleCloseNavMenu = (url: string) => {
    // navigate to href id anchor
    const element = document.getElementById(url);
    if (element) {
      const yOffset = -APP_BAR_HEIGHT;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }

    setDrawerOpen(false);
  };

  return (
    <StyledAppBar position="sticky">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* MOBILE */}
          <Typography
            variant="h5"
            noWrap
            onClick={scrollToTop}
            sx={{
              cursor: 'pointer',
              mr: 'auto',
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontWeight: 600,
              color: 'inherit',
              textDecoration: 'none',
              fontFamily: 'Silka, sans-serif',
              letterSpacing: '0.09rem',
            }}
          >
            {SITE_NAME}
          </Typography>

          {/* MOBILE */}
          <Box sx={{ justifyContent: 'space-between', display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={() => setDrawerOpen(true)}
              color="inherit"
            >
              <FontAwesomeIcon icon={faBars} />
            </IconButton>
            <Drawer
              id="menu-appbar"
              keepMounted
              open={drawerOpen}
              sx={{ display: { xs: 'block', md: 'none' } }}
              slotProps={{
                paper: {
                  sx: {
                    width: '100%',
                    maxWidth: '100%',
                    left: '0px',
                    top: '0px',
                    margin: 0,
                    padding: 0,
                    borderRadius: 0,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 2,
                  },
                },
              }}
            >
              <IconButton
                onClick={() => setDrawerOpen(false)}
              >
                <FontAwesomeIcon icon={faXmark} color={TEXT_PRIMARY} />
              </IconButton>
              <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
                {PAGES.map((page) => (
                  <MenuItem key={page.name} onClick={() => handleCloseNavMenu(page.url)}>
                    <Typography
                      sx={{
                        color: TEXT_PRIMARY,
                        textAlign: 'center',
                        fontFamily: 'Silka, sans-serif',
                        letterSpacing: '0.03rem',
                        textTransform: "uppercase"
                      }}
                    >
                        {page.name}
                    </Typography>
                  </MenuItem>
                ))}
              </Stack>
              <IconLinks />
            </Drawer>
          </Box>

          {/* DESKTOP */}
          <Typography
            variant="h6"
            noWrap
            onClick={scrollToTop}
            sx={{
              cursor: 'pointer',
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
              fontFamily: 'Silka, sans-serif',
              letterSpacing: '0.03rem',
            }}
          >
            {SITE_NAME}
          </Typography>

          {/* DESKTOP */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, height: '100%' }}>
            {PAGES.map((page) => (
              <Button
                key={page.name}
                onClick={() => handleCloseNavMenu(page.url)}
                sx={{
                  my: 2,
                  color: 'white',
                  display: 'block',
                  fontFamily: 'Silka, sans-serif',
                  letterSpacing: '0.03rem'
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </StyledAppBar>
  );
}
